import { render, staticRenderFns } from "./InstallerDashboardMainFeature.vue?vue&type=template&id=6ab9e2d6&scoped=true&"
import script from "./InstallerDashboardMainFeature.vue?vue&type=script&lang=js&"
export * from "./InstallerDashboardMainFeature.vue?vue&type=script&lang=js&"
import style0 from "./InstallerDashboardMainFeature.vue?vue&type=style&index=0&id=6ab9e2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab9e2d6",
  null
  
)

export default component.exports